"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarIcon = void 0;
/* eslint-disable prettier/prettier */
var React = require("react");
var CalendarIcon = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" },
    React.createElement("path", { fill: "#4996B2", fillRule: "evenodd", d: "M14 5h-2V4h-1v1H9V4H8v1H6c-.5 0-1 .5-1 1v7c0 .5.5 1 1 1h8c.5 0 1-.5 1-1V6c0-.5-.5-1-1-1zm0 8H6V9h8v4zm0-5H6V6h2v1h1V6h2v1h1V6h2v2z" }))); };
exports.CalendarIcon = CalendarIcon;
//# sourceMappingURL=CalendarIcon.js.map